import { Form } from 'antd';
import authService from 'modules/auth/services';
import authApis from 'modules/auth/services/apis';
import { IAuthData } from 'modules/auth/services/types';
import { useNavigate } from 'react-router-dom';
import { IResponseData } from 'services/response';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import delayTime from 'utils/await';
import { setPageLoading } from 'widgets/PageLoading';
import useDeviceSelection from '../StoreSelection/useDeviceSelection';
import FormLogin from './FormLogin';
import OverlayBG from './OverlayBG';
import Policy from './Policy';

const Container = styled.div`
  position: relative;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 60px;
`;

const LoginPage = () => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [onChooseStore, contextSelection] = useDeviceSelection();

  const handleFinish = async (values: any) => {
    setPageLoading(true);
    try {
      const res: IResponseData<IAuthData> = await authApis.login({ userName: values.username, password: values.password });
      if (res.data.data) {
        dispatch(authService.slice.actions.saveAuthData(res.data.data));
        await delayTime(200);
        if (res.data.data.stores?.length === 1) {
          return onChooseStore(res.data.data.stores?.[0]?.id || '');
        }
        navigate('/stores');
      }
    } catch (error) { }
    finally {
      setPageLoading(false);
    }
  };
  return (
    <>
      <OverlayBG />
      <Container>
        <FormLogin form={form} onFinish={handleFinish} initialValues={{ username: 'retail@fozito.com', password: '123456789' }} />
        <Policy />
      </Container>
      {contextSelection}
    </>
  );
};

export default LoginPage;

